var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-modal-view',{class:_vm.Info.Dialog.Summary.Class,attrs:{"title":_vm.Info.Dialog.Summary.Title,"width":800},on:{"init":_vm.handleModal_init}},[_c('List',{attrs:{"items":_vm.summaryList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }